import { DynamicIcon, iconNames } from 'lucide-react/dynamic';
import type { FC } from 'react';

// https://stackoverflow.com/a/52331580
type Unpacked<T> = T extends (infer U)[] ? U : T;
type IconName = Unpacked<typeof iconNames>;

// Icon names are free-text, admin-entered Firestore data (see SpaceDetails/CatalogTab
// forms) and aren't validated against lucide's name list on write, so an unrecognized name must
// fall back rather than crash — matches the "defaults to 'house'" behavior documented in-app.
const FALLBACK_ICON: IconName = 'house';
const iconNameSet: ReadonlySet<string> = new Set(iconNames);

const AppIcon: FC<{ icon: string; size?: number | string }> = ({ icon, size = 16 }) => {
    const name = iconNameSet.has(icon) ? (icon as IconName) : FALLBACK_ICON;
    return <DynamicIcon size={size} name={name} />;
};

export default AppIcon;
